import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import {
    AppNotificationService,
    ClientManagerInstanceToken,
    ClientManagerInterface,
    DataMaintenanceLocationModel,
    DataMaintenanceUtilities,
    SynchronizationService,
} from '@evorait/pace-core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-data-maintenance-location',
    templateUrl: './data-maintenance-location.component.html',
    styleUrls: ['./data-maintenance-location.component.scss'],
    standalone: false,
})
export class DataMaintenanceLocationComponent implements OnInit, OnDestroy {
    @Input()
    public model: DataMaintenanceLocationModel;

    public footer: string;

    public formChildren: FormArray;
    public dataMaintenanceLocationForm: FormGroup;
    public isLoading = false;
    public destroyTrigger = new Subject<void>();
    public oldModel: DataMaintenanceLocationModel;
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly translate: TranslateService,
        private readonly appNotificationService: AppNotificationService,
        public readonly modalInstance: BsModalRef,
        private readonly formBuilder: FormBuilder,
        private readonly synchronizationService: SynchronizationService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly dataMaintenanceUtilities: DataMaintenanceUtilities,
    ) {}

    public ngOnInit(): void {
        this.footer = <string>this.translate.instant('NOTIFICATION_DETAIL_DATA_MAINTENANCE_LOCATION_SEND_DATA');

        this.formChildren = this.formBuilder.array([]);
        this.dataMaintenanceLocationForm = this.formBuilder.group({
            formChildren: this.formChildren,
        });
        if (this.model instanceof DataMaintenanceLocationModel) {
            this.oldModel = _.cloneDeep(this.model);
        }
    }

    public ngOnDestroy(): void {
        this.destroyTrigger.next();
    }

    public submit(): void {
        this.dataMaintenanceUtilities.updateRecipientListInLocalStorage(cloneDeep(this.model));
        this.dataMaintenanceUtilities.openMailToSubmitData(this.model, this.oldModel, this.oldModel.isInvitro);
        this.modalInstance.hide();
    }
}
